import * as api from '../resources/login-popup.api';
import actionTypes from './action-types';

export const fetchLoginPopupRequest = () => ({
  type: actionTypes.FETCH_LOGIN_POPUP_REQUEST,
  isLoading: true,
});

export const fetchLoginPopupSuccess = (result) => ({
  type: actionTypes.FETCH_LOGIN_POPUP_SUCCESS,
  result,
  isLoading: false,
});

export const fetchLoginPopupFailure = () => ({
  type: actionTypes.FETCH_LOGIN_POPUP_FAILURE,
  isLoading: false,
});

export const fetchPopup = () => async (dispatch, getState) => {
  try {
    const { config } = getState();
    const { secondHandApproval, jurisdictionId } = config;

    dispatch(fetchLoginPopupRequest());
    const result = await api.fetchPopup(secondHandApproval, jurisdictionId);
    dispatch(fetchLoginPopupSuccess(result));
  } catch (error) {
    console.error('FETCH_LOGIN_POPUP', error);
    dispatch(fetchLoginPopupFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/login-popup.actions.js